import * as React from 'react'
import './index.scss'
import Pop from './Pop'
import classNames from 'classnames'
import { regFenToYuan } from './../../../utils'
interface PopInterface {
  close: any
  tTotal: any
}
const { useMemo } = React
const PopAward: React.FC<PopInterface> = props => (
  <Pop>
    <div className='pop-award'>
      <i className='icon' />
      <i className='close' onClick={() => props.close()} />
      <div className='cash'>{regFenToYuan(props.tTotal.lPrice, 0)}</div>
      <p className='cash-desc'>共{regFenToYuan(props.tTotal.lPrice, 0)}元现金</p>
      <i className='award-desc' />
      <ul className='award-list'>
        <li>
          <i className={classNames('award-item', { Jf: 1 })} />
          <p className='award-count'>x{props.tTotal.lPoint}</p>
        </li>
        <li>
          <i className={classNames('award-item', { Exp: 1 })} />
          <p className='award-count'>x{props.tTotal.lExp}</p>
        </li>
        {
          useMemo(() => {
            const hl = props.tTotal.vGift.value.filter(item => parseInt(item.iItemType as string, 10) === 4)
            const count = hl.length === 1 ? hl[0].iItemCount : 0
            return (
              <li>
                <i className={classNames('award-item', { Hl: 1 })} />
                <p className='award-count'>x{count}</p>
              </li>
            )
          }, [props.tTotal.vGift])
        }
        {
          useMemo(() => {
            const yd = props.tTotal.vGift.value.filter(item => parseInt(item.iItemType as string, 10) === 8)
            const count = yd.length === 1 ? yd[0].iItemCount : 0
            return (
              <li>
                <i className={classNames('award-item', { Yd: 1 })} />
                <p className='award-count'>x{count}</p>
              </li>
            )
          }, [props.tTotal.vGift])
        }
      </ul>
      <div className='pop-btn' onClick={() => props.close()}>我知道了</div>
    </div>
  </Pop>
)

export default PopAward